(function () {
  'use strict';
  // Carla Orsini · Galerías específicas por color.
  // IDs de medios verificados en Shopify. No modifica ni borra archivos.
  const GROUPS = {"10951619739987":{"chocolate":["62856705999187","62856706031955","62856706064723","62988798886227"],"camel":["62988951880019","62988952699219","62988956696915","62988959154515"],"verde oliva":["62989009682771","62989010862419","62989011648851","62989021020499"],"teja":["62989082722643","62989083902291","62989084262739","62989084328275"]},"10858790486355":{"negro":["62562692563283","62962238194003","62989143474515","62962273681747"],"gris piedra":["62558663967059","62962277450067","62989147210067","62962290491731"],"marron cafe":["62558663835987","62558663704915","62989152387411","62962300846419"],"azul marino":["62558663672147","62558663803219","62989153173843","62962309792083"]},"10858790453587":{"blanco roto":["62558782128467"],"camel":["62558782325075"],"negro":["62558782226771"],"blanco":["62558782128467"],"gris perla":["62555812528467"],"azul noche":["62562691711315"],"burdeos":["62562692333907"]}};
  const clean = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  const mediaId = (value) => String(value || '').split('-').pop();
  const selectors = 'product-info[data-product-id]';

  function currentVariant(root) {
    try {
      const node = root.querySelector('variant-selects [data-selected-variant]');
      return JSON.parse(node?.textContent || 'null');
    } catch (error) {
      return null;
    }
  }

  function currentColor(root, variant) {
    const firstOption = variant?.options?.[0] || variant?.option1;
    if (firstOption) return clean(firstOption);
    const selected = root.querySelector('variant-selects fieldset input:checked, variant-selects select option:checked');
    return clean(selected?.value);
  }

  function context(root) {
    const gallery = root.querySelector('media-gallery');
    const viewer = gallery?.querySelector('slider-component[id^="GalleryViewer"]');
    const list = viewer?.querySelector('ul[id^="Slider-Gallery"]');
    if (!gallery || !viewer || !list) return null;
    const thumbs = gallery.querySelector('slider-component[id^="GalleryThumbnails"]');
    const thumbList = thumbs?.querySelector('ul[id^="Slider-Thumbnails"]') || null;
    return { gallery, viewer, list, thumbs, thumbList };
  }

  function filterList(list, attr, ids) {
    if (!list) return;
    const wanted = new Set(ids);
    const nodes = Array.from(list.querySelectorAll('li[' + attr + ']'));
    const map = new Map(nodes.map(node => [mediaId(node.getAttribute(attr)), node]));
    // Recolocar únicamente el color activo, siempre en el orden frontal/lateral/espalda/detalles.
    const fragment = document.createDocumentFragment();
    ids.forEach(id => { if (map.has(id)) fragment.appendChild(map.get(id)); });
    list.prepend(fragment);
    nodes.forEach(node => {
      const allowed = wanted.has(mediaId(node.getAttribute(attr)));
      node.classList.toggle('co-color-media-hidden', !allowed);
      node.setAttribute('aria-hidden', allowed ? 'false' : 'true');
      if (allowed) node.removeAttribute('inert');
      else node.setAttribute('inert', '');
    });
  }

  function filterModal(root, ids) {
    const modal = root.querySelector('product-modal');
    if (!modal) return;
    const wanted = new Set(ids);
    modal.querySelectorAll('[data-media-id]').forEach(item => {
      const ok = wanted.has(mediaId(item.dataset.mediaId));
      item.classList.toggle('co-color-media-hidden', !ok);
      item.setAttribute('aria-hidden', ok ? 'false' : 'true');
      if (ok) item.removeAttribute('inert');
      else item.setAttribute('inert', '');
    });
  }

  function showColor(root, variant) {
    const byColor = GROUPS[root.dataset.productId];
    if (!byColor) return;
    const color = currentColor(root, variant);
    const expected = byColor[color];
    if (!expected) return;
    const ctx = context(root);
    if (!ctx) return;
    const existing = new Set(Array.from(ctx.list.querySelectorAll('li[data-media-id]')).map(n => mediaId(n.dataset.mediaId)));
    const ids = expected.filter(id => existing.has(id));
    if (!ids.length) return; // Nunca ocultar la galería si faltan los medios de un color.
    root.dataset.coVariantGalleryReady = 'true';
    ctx.gallery.dataset.coVariantGalleryReady = 'true';
    filterList(ctx.list, 'data-media-id', ids);
    filterList(ctx.thumbList, 'data-target', ids);
    ids.forEach((id, index) => {
      const thumb = ctx.thumbList?.querySelector('[data-target$="-' + id + '"]');
      if (thumb) thumb.dataset.mediaPosition = String(index + 1);
    });
    filterModal(root, ids);
    const first = ctx.list.querySelector('[data-media-id$="-' + ids[0] + '"]');
    ctx.list.querySelectorAll('li[data-media-id]').forEach(n => n.classList.toggle('is-active', n === first));
    const firstThumb = ctx.thumbList?.querySelector('[data-target$="-' + ids[0] + '"]');
    if (ctx.thumbList) ctx.thumbList.querySelectorAll('button').forEach(b => b.removeAttribute('aria-current'));
    firstThumb?.querySelector('button')?.setAttribute('aria-current', 'true');
    // Mantener únicamente el paginador nativo del tema, ya vinculado a las miniaturas.
    ctx.gallery.querySelector('.co-color-gallery-dots')?.remove();
    requestAnimationFrame(() => {
      const track = ctx.viewer.slider;
      if (track) {
        track.scrollLeft = 0;
      }
      ctx.viewer.resetPages?.();
      ctx.thumbs?.resetPages?.();
    });
  }

  function initAll() {
    document.querySelectorAll(selectors).forEach(root => {
      if (!GROUPS[root.dataset.productId]) return;
      showColor(root, currentVariant(root));
    });
  }

  function start() {
    initAll();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, payload => {
        const data = payload?.data || {};
        const root = document.querySelector('product-info[data-section="' + data.sectionId + '"]');
        if (root && GROUPS[root.dataset.productId]) showColor(root, data.variant);
      });
    }
    document.addEventListener('shopify:section:load', initAll);
    window.addEventListener('popstate', () => requestAnimationFrame(initAll));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();